'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { FormLabel } from '../../_internal/FormLabel/FormLabel';
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Renders a FormLabel linked to the field's
 * control via the FieldContext id. Consumers only need this in the 10% slot
 * decomposition case — Field's `label` prop is sufficient for standard use.
 */
export function FieldLabel({ children, required }) {
    const ctx = useFieldContext();
    const isRequired = required ?? ctx?.required ?? false;
    return (_jsx(FormLabel, { htmlFor: ctx?.ids.control, required: isRequired, children: children }));
}
//# sourceMappingURL=FieldLabel.js.map